const advertise = {
  dfdh: 'Телефон контрагента:',
  sjmc: 'Название магазина',
  qsrsj: 'Введите название магазина',
  sjbzj: 'Депозит магазина',
  wcl: 'Процент выполнения за 30 дней',
  zcd: 'Всего ордеров (покупка/продажа)',
  cd: 'Ордеров за 30 дней',
  c: 'раз(а)',
  fz: 'минут',
  pjfx: 'Среднее время выпуска',
  zcsj: 'Дата регистрации:',
  fbjy: 'Первое посещение P2P-торговли:',
  yxbd: 'Привязка email',
  sjbd: 'Привязка телефона',
  cjsm: 'Базовая верификация',
  gjsm: 'Расширенная верификация',
  buy: 'Купить',
  sell: 'Продать',
  market: 'Рынок',
  djfs: 'Способ ценообразования',
  ggid: 'ID объявления',
  time: 'Время',
  type: 'Тип',
  ptgg: 'Обычное объявление',
  gdjg: 'Фиксированная цена',
  fdjg: 'Плавающая цена',
  yjfw: 'Диапазон наценки',
  unitPrice: 'Цена за единицу',
  totalPrice: 'Общая сумма',
  sysl: 'Остаток',
  ywcsl: 'Выполненный объём',
  cz: 'Действие',
  xj: 'Снять с публикации',
  sj: 'Опубликовать',
  edit: 'Редактировать',
  delete: 'Удалить',
  all: 'Все',
  qdxjm: 'Подтвердить снятие этого объявления с публикации?',
  qdxj: 'Подтверждение снятия',
  qdsjm: 'Подтвердить публикацию этого объявления?',
  qdsj: 'Подтверждение публикации',
  confirm: 'Подтвердить',
  cancel: 'Отмена',
  qdscm: 'Подтвердить удаление этого объявления?',
  deleteAdvertise: 'Удалить объявление',

  tjgm: 'Статистика покупок',
  tjcs: 'Статистика продаж',
  coins: 'Монета',
  day7: '7 дней',
  day15: '15 дней',
  day30: '30 дней',
  tj: 'Статистика',
  mrsl: 'Объём покупок',
  mcsl: 'Объём продаж',
  mrjj: 'Средняя цена покупки',
  mcjj: 'Средняя цена продажи',
  zcje: 'Сумма расходов',
  srje: 'Сумма доходов',
  zsxf: 'Общая комиссия',
  cjdd: 'Исполненные ордера',
  zdxx: 'Информация по счету',
  tips: 'Примечание. Для каждой торговой пары статистику покупок и продаж можно экспортировать не более 100 раз в день.',
  dcdd: 'Экспорт ордеров',
  orderNo: 'Номер ордера',
  jybz: 'Торговая монета',
  number: 'Количество',
  total: 'Общая сумма',
  fee: 'Комиссия',
  zd: 'Счёт',

  tjskfs: 'Добавить способ оплаты',
  skfs: 'Способ оплаты',
  name: 'Имя',
  payAccount: 'Счёт',
  sk: 'Получение платежа',
  delete: 'Удалить',
  edit: 'Изменить',
  qdsc: 'Подтвердить удаление?',
  tip: 'Подсказка',
  deleted: 'Удаление отменено',
  xzskfstt: 'Новый способ оплаты',
  xgskfstt: 'Изменить способ оплаты',
  khmc: 'Имя владельца счёта',
  yhkh: 'Номер банковской карты',
  khh: 'Банк-эмитент',
  khhszd: 'Местонахождение банка',
  khhmc: 'Название банка',
  wxzh: 'Аккаунт WeChat',
  zfbzf: 'Платёж через Alipay',
  ewmsc: 'Загрузить QR-код',
  jymm: 'Торговый пароль',
  srkhh: 'Введите банк-эмитент',
  xzszd: 'Выберите местонахождение банка',
  srkhmc: 'Введите название банка',
  srzh: 'Введите номер счёта',
  scskm: 'Загрузите платёжный QR-код',
  srjymm: 'Введите торговый пароль',
  scwjgd: 'Размер загружаемого аватара не должен превышать 2 МБ!',

  jnbzj1: 'Вы как {gradeName} внесли депозит {margin} USDT, ваш текущий лимит на объявления составляет {amount} USDT',
  k: 'Можно',
  add: 'Увеличить',
  or: 'или',
  reduce: 'Уменьшить',
  margin: 'Депозит',
  sqsxf: '*Платформа взимает комиссию {fee}% с объёма сделок продавца',
  hqed: 'Станьте верифицированным продавцом сейчас, чтобы получить более высокий лимит',
  want: 'Я хочу',
  bb: 'Coin-to-Coin',
  price: 'Цена',
  ckj: '*Рыночная ориентировочная цена {price} {fiatCurrency}/USDT. Фиксированная цена не следует за рыночными колебаниями',
  jyjg: 'Цена сделки',
  mdjg: 'Привязка цены',
  gxhl: '*Интегрированный курс от банков и бирж, обновляется каждые 5 минут',
  szyj: 'Установить наценку',
  zjjy: '*Можно вводить отрицательные значения для торговли со скидкой относительно привязанной цены',
  yjsz: '*Цена сделки = Привязанная цена * (1 + Наценка)',
  jyxz: 'Торговые ограничения',
  jysl: 'Торговый объём',
  sygged: '*Торговый объём не может превышать текущий лимит объявления',
  zxxe: 'Мин. сумма за ордер',
  zdxe: 'Макс. сумма за ордер',
  fkqx: 'Срок оплаты',
  xnfk: '*Платёж должен быть произведён в течение этого времени',
  fkfs: 'Способ оплаты',
  xzskfs: '*Всего можно добавить до 5 способов оплаты для всех монет',
  yhjy: 'Не торговать с пользователями, не прошедшими расширенную верификацию',
  jygg: '*Пользователи только с базовой верификацией не могут участвовать в объявлениях',
  cyjy: 'Выберите пользователей, которые не выполнили указанное количество покупок; они не могут участвовать в торговле',
  bmfx: '*Пользователи, совершавшие покупки, значительно снижают риск происхождения средств',
  qxz: 'Выберите',
  jybz: 'Примечание к сделке',
  tyzs: 'Я принимаю и соглашаюсь соблюдать',
  jygz: 'Правила торговли',
  yzm: 'Код подтверждения',
  save: 'Сохранить',
  fbgg: 'Опубликовать объявление',
  jsbzjcg: 'Депозит успешно уменьшен',
  zjbzjcg: 'Депозит успешно увеличен',
  xzfs: 'Выберите способ получения или отправки платежа',
  bankTip1: 'Не более трёх банковских карт',
  wxTip2: 'Не более трёх аккаунтов WeChat',
  zfbTip3: 'Не более трёх аккаунтов Alipay',
  syjg: 'Введите цену',
  syjysl: 'Введите торговый объём',
  zxxe: 'Введите мин. сумму за ордер',
  zdxe: 'Введите макс. сумму за ордер',
  fkqx: 'Введите срок оплаты',
  tyjygz: 'Примите правила торговли',
  tpyzm: 'Введите код подтверждения с картинки',
  jydx: 'Контрагент',

  zjbzj: 'Увеличить депозит',
  jsbzj: 'Уменьшить депозит',
  xzdgged: 'Текущий макс. лимит объявления',
  zjbzjse: 'Сумма увеличения депозита',
  jsbzjse: 'Сумма уменьшения депозита',
  zjhbzjed: 'Сумма депозита после увеличения',
  jshbzjed: 'Сумма депозита после уменьшения',
  balance: 'Баланс',
  sy: 'Остаток',
  kzj: 'Доступно для увеличения',
  kjs: 'Доступно для уменьшения',
  otcsjxy: 'Правила и соглашения для P2P-продавцов',
  xsgz: 'Руководство для новичков',
  jygz: 'Правила торговли',
  jnbzj: 'Для обеспечения легальности и соответствия требованиям P2C, а также регулирования поведения всех сторон, продавцы обязаны внести определённый депозит.',
  zjjnbzj: 'Депозит состоит из базовой и дополнительной частей. Базовая часть обязательна, дополнительная — по желанию.',
  kxs: 'Внесение базовой суммы депозита даёт право на',
  fbgged: 'лимит объявления (в пересчёте на CNYT по курсу)',
  ggedbl: 'Соотношение дополнительного депозита к лимиту объявления составляет',
  eg: 'Например, при добавлении 100 USDT лимит объявления увеличивается сверх базового на 100 x',
  ggzedjs: 'Формула расчёта общего лимита объявления: базовый лимит + дополнительный депозит x',
  ttsjzxed: 'Минимальная сумма для увеличения депозита обычным продавцом составляет',
  zdedw: 'Максимальная сумма',
  mgsjzd: 'Каждый продавец может опубликовать не более трёх объявлений на покупку и трёх на продажу.',
  hljj: 'Курс USDT к CNYT берётся со средней цены за последние 24 часа на бирже BiKing по соответствующей паре (записывается каждый час, без учёта максимума и минимума) и используется как текущий курс. При колебаниях курса лимит уже опубликованных объявлений остаётся неизменным.',
  jcbzj: 'Базовый депозит',
  xt: 'Необязательно',
  njhded: 'Ваш будущий лимит объявления:',
  mbye: 'Баланс для покупки:',
  zhzcbz: 'Недостаточно средств на счёте. Вы можете перевести средства с капитального счёта',
  qhz: 'Перевести',
  qdjnbzj: 'Подтвердить внесение базового депозита',
  tjbzj: 'Внести депозит',
  sqsjcg: 'Заявка на статус продавца одобрена',
  exchange: 'Сменить валюту'
}
export {
    advertise
}


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/ru.js